const carContainerTypes = {
  "MY_GARAGE": "MY_GARAGE",
  "UPCOMING_CARS": "UPCOMING_CARS",
  "LIVE_AUCTION": "LIVE_AUCTION",
  "BUY_NOW": "BUY_NOW",
  "ORDER_CARD": "ORDER_CARD",
  "CARS_IN_NEGOTIATION": "CARS_IN_NEGOTIATION",
  "SOLD_CARS": "SOLD_CARS",
  "UNSOLD_CARS": "UNSOLD_CARS",
  "REJECTED_CARS": "REJECTED_CARS",
  "DISAPPROVED_CARS": "DISAPPROVED_CARS",
  "WATCH_LIST": "WATCH_LIST",
};

export {
  carContainerTypes
};